import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const CookiesPage: React.FC = () => {
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="pt-32 md:pt-44 pb-16 px-4">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl md:text-4xl font-bold text-white mb-8">{t('cookiesPage.title')}</h1>

        {/* Company Info */}
        <div className="bg-[#161616] border border-[#2a2a2a] rounded-xl p-6 mb-8">
          <h2 className="text-xl font-semibold text-white mb-4">{t('cookiesPage.operatorTitle')}</h2>
          <div className="grid sm:grid-cols-2 gap-4 text-sm">
            <div>
              <span className="text-gray-500">{t('cookiesPage.companyName')}:</span>
              <p className="text-gray-300">FBS group, s. r. o.</p>
            </div>
            <div>
              <span className="text-gray-500">{t('cookiesPage.regSeat')}:</span>
              <p className="text-gray-300">Tatranská Lomnica 14649, 059 60 Vysoké Tatry</p>
            </div>
            <div>
              <span className="text-gray-500">IČO:</span>
              <p className="text-gray-300">44898487</p>
            </div>
            <div>
              <span className="text-gray-500">Web:</span>
              <p className="text-gray-300">www.fbs-group.sk</p>
            </div>
          </div>
        </div>

        <div className="space-y-8 text-gray-300 text-sm leading-relaxed">
          <section>
            <h2 className="text-lg font-semibold text-white mb-3">{t('cookiesPage.section1Title')}</h2>
            <p>{t('cookiesPage.section1Text')}</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">{t('cookiesPage.section2Title')}</h2>
            <div className="space-y-4">
              <div className="bg-[#161616] border border-[#2a2a2a] rounded-lg p-4">
                <h3 className="text-white font-medium mb-1">{t('cookiesPage.necessaryTitle')}</h3>
                <p className="text-gray-400 text-xs">{t('cookiesPage.necessaryDesc')}</p>
              </div>
              <div className="bg-[#161616] border border-[#2a2a2a] rounded-lg p-4">
                <h3 className="text-white font-medium mb-1">{t('cookiesPage.analyticsTitle')}</h3>
                <p className="text-gray-400 text-xs">{t('cookiesPage.analyticsDesc')}</p>
              </div>
              <div className="bg-[#161616] border border-[#2a2a2a] rounded-lg p-4">
                <h3 className="text-white font-medium mb-1">{t('cookiesPage.marketingTitle')}</h3>
                <p className="text-gray-400 text-xs">{t('cookiesPage.marketingDesc')}</p>
              </div>
              <div className="bg-[#161616] border border-[#2a2a2a] rounded-lg p-4">
                <h3 className="text-white font-medium mb-1">{t('cookiesPage.personalizationTitle')}</h3>
                <p className="text-gray-400 text-xs">{t('cookiesPage.personalizationDesc')}</p>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">{t('cookiesPage.section3Title')}</h2>
            <p>{t('cookiesPage.section3Text')}</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">{t('cookiesPage.section4Title')}</h2>
            <p>{t('cookiesPage.section4Text')}</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">{t('cookiesPage.section5Title')}</h2>
            <p>{t('cookiesPage.section5Text')}</p>
            <p className="mt-2 text-gray-400">Email: info@fbsgroup.sk</p>
          </section>

          <div className="border-t border-[#2a2a2a] pt-6 text-gray-500 text-xs">
            {t('cookiesPage.lastUpdated')}: 13.03.2026
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookiesPage;
